import React from "react";
import { ShelterBedMetric } from "./ShelterBedMetric";

export const ShelterOccupiedMetric = ({ data }: any) => (
  <ShelterBedMetric
    data={data}
    title="Occupied Beds"
    subtitle=""
    tooltip="Beds with a person in them, whether assigned individually or as part of a whole dwelling or family room."
    field="occupied_beds"
  />
);
